module.exports = __webpack_public_path__ + "static/selene1-691a67bfef26d5b1d45bf6e0064b1266.png";